<template>
  <div class="charts-pie"></div>
</template>

<script>
import ECharts from "echarts/lib/echarts";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
export default {
  data() {
    return {
      charts: null
    };
  },
  props: {
    options: [Object],
    loading: { type: Boolean, default: true },
    FullNamedata: {
      type: Array
      //   default:
    }
  },
  watch: {
    options: {
      handler(val) {
        this.charts.setOption(val);
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    // console.log(this.FullNamedata);
    let FullNamedatas = [];
    let FullNamedatas2 = {};
    this.FullNamedata.find(tiem => {
      Number(tiem.value);
      
      if (tiem.value > 0 || tiem.value == 0) {
        FullNamedatas.push(tiem);
      } else {
        FullNamedatas2 = tiem;
      }
    });

    this.charts = ECharts.init(this.$el, {
      color: [
        "#c12e34",
        "#e6b600",
        "#0098d9",
        "#2b821d",
        "#005eaa",
        "#339ca8",
        "#cda819",
        "#32a487",
        "#ff6"
      ]
    });
    let option = {
      title: { text: "银行账户图形", subtext: "", x: "center" },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      calculable: true,
      series: [
        {
          name: "名称",
          type: "pie",
          radius: "55%",
          center: ["60%", "50%"],
          label: {
            normal: {
              formatter: `{b} ${FullNamedatas2.value > 0 ? "-" : ""} {d}%`
            }
          },
          data: [...FullNamedatas]
        }
      ]
    };
    // option 是做测试用的，可以去掉直接通过prop传值修改
    option = Object.assign(option, this.Object);

    this.charts.setOption(option);
  },
  name: "charts-pie"
};
</script>

<style scoped>
.charts-pie {
  width: 100%;
  height: 544px;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/echarts/echarts.vue